<script setup>
import { AbcIcon } from "@ordbogen-npm/abc-dsk";

import { color as colorProp, disabled as disabledProp } from "@/abc-dsk/props";

import { CLASS_NAME_COMPONENT_CHECKBOX } from "./common";

const props = defineProps({
  disabled: disabledProp,
  color: {
    type: colorProp.type,
    validator: colorProp.validator,
    default: "secondary"
  },
  modelValue: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: undefined
  }
});

defineEmits(["update:modelValue"]);

const baseClass = CLASS_NAME_COMPONENT_CHECKBOX;
</script>

<template>
  <div :class="[baseClass, props.disabled ? `${baseClass}--disabled` : '']">
    <input
      :checked="props.modelValue"
      :disabled="props.disabled"
      :name="props.name"
      :class="[`${baseClass}__input`, `${baseClass}__input--${props.color}`]"
      type="checkbox"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <AbcIcon name="check-mark" :class="`${baseClass}__checkmark`" />
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.tg-checkbox {
  display: inline-flex;
  position: relative;
  cursor: pointer;

  &__input {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    outline: none;
    cursor: pointer;
    appearance: none;

    &:disabled {
      border: 2px solid rgb(@theme-colors[@grey][50]);
      background-color: @colors[@white];
      cursor: not-allowed;

      &:checked {
        background-color: rgb(@theme-colors[@grey][50]);
      }
    }

    each(@theme-colors, {
      @name: replace(@key, "@", "");

      &--@{name} {
        border: 2px solid rgb(@value[base]);

        &:checked:not(:disabled) {
          background-color: rgb(@value[base]);
        }

        &:focus:not(:disabled) {
          box-shadow: 0px 0px 0px 3px rgba(@value[base], 0.3);
        }
      }
    });
  }

  &__checkmark {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    color: @colors[@white];

    &:focus {
      outline: none;
    }
  }

  &__input:checked + .tg-checkbox__checkmark {
    display: block;
  }
}
</style>
